import { Auth } from "src/domains/shared/utils/amplifyCompat";
import { clearCognitoSessionStorage } from "src/domains/shared/utils/injectCognitoSession";

/**
 * IdP 로그아웃 상한. Amplify 로컬 `signOut()` 은 RevokeToken 응답 뒤에 토큰을 지우는데 자체 타임아웃이 없다.
 * 상한을 넘기면 토큰을 직접 지운다 — 화면을 옮기기 전에 토큰이 사라져야 가드가 로그인 화면을 건너뛰지 않는다.
 */
const SIGN_OUT_TIMEOUT_MS = 5_000;

/**
 * 이 브라우저에서만 로그아웃한다. `Auth.signOut()` 을 인자 없이 부른다 — 전역 로그아웃은 다른 기기(자리를
 * 가진 새 로그인)의 토큰까지 폐기하므로 쓰지 않는다. 상한(기본 5초)을 넘기거나 실패하면
 * `clearCognitoSessionStorage()` 로 세션 키를 직접 지운다. 언제나 resolve 한다.
 */
export async function signOutThisBrowser({
  timeoutMs = SIGN_OUT_TIMEOUT_MS,
}: { timeoutMs?: number } = {}): Promise<void> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const deadline = new Promise<"timedOut">((resolve) => {
    timer = setTimeout(() => resolve("timedOut"), timeoutMs);
  });

  try {
    const outcome = await Promise.race([
      Auth.signOut().then(() => "signedOut" as const),
      deadline,
    ]);
    if (outcome === "timedOut") clearCognitoSessionStorage();
  } catch {
    clearCognitoSessionStorage();
  } finally {
    clearTimeout(timer);
  }
}
